import { createContext } from "react";
import { useGetLatestVisitsQuery } from "src/api/services/visitApi";
import { OnlineVisitBase } from "src/api/types";

export const LatestOnlineVisitsContext = createContext<OnlineVisitBase[]>([]);

interface Props {
  children: React.ReactNode;
}

const LatestOnlineVisitsProvider = ({ children }: Props) => {
  const { data = [], isLoading } = useGetLatestVisitsQuery();

  if (isLoading === true) {
    return;
  }

  return (
    <LatestOnlineVisitsContext.Provider value={data}>
      {children}
    </LatestOnlineVisitsContext.Provider>
  );
};

export default LatestOnlineVisitsProvider;
